import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";

export type ParcelQueryParams = {
  number: SearchReferenceDTO;
  carrierCode?: string;
};
